import React, { useState } from "react";
import Modal from "react-modal";
import { IServiceCategory } from "app/api/types";
import EditServiceCategoryForm from "app/components/EditServiceCategoryForm";

import "./styles.scss";

interface IProps {
  serviceCategory: IServiceCategory;
  onSubmit: (data: IServiceCategory) => void;
  onDelete: (data: IServiceCategory["id"]) => void;
}

Modal.setAppElement("#root");

const ServiceCategory: React.FC<IProps> = props => {
  const [isCollapsed, setCollapse] = useState(true);
  const [isDeleting, setDelete] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);

  const triggerCollapse = () => {
    setCollapse(!isCollapsed);
  };

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const onDelete = () => {
    setDelete(true);

    props.serviceCategory.id !== "1" &&
      props.onDelete(props.serviceCategory.id);
  };

  const styles = {
    height: !isCollapsed ? "220px" : "60px"
  };

  return (
    <div
      className={`phrase-container ${isDeleting ? "deleting" : ""}`}
      style={styles}
    >
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Add phrase modal"
        className="user-group__modal"
        overlayClassName="user-group__overlay"
      >
        <div className="category-remove-modal-container">
          <div className="container-text">
            <p>Все услуги, принадлежащие категории, будут удалены.</p>
            <p className="text__continue"> Продолжить?</p>
          </div>

          <div className="container-controls">
            <button
              onClick={onDelete}
              className="controls__btn controls__btn_remove"
            >
              Удалить
            </button>
            <button
              onClick={closeModal}
              className="controls__btn controls__btn_cancel"
            >
              Отмена
            </button>
          </div>
        </div>
      </Modal>

      <div className="phrase-wrapper">
        <div className="left-block" onClick={triggerCollapse}>
          <div className="phrase-text">{props.serviceCategory.title}</div>
        </div>

        <div className="right-block">
          {props.serviceCategory.id !== "1" && (
            <p className="phrase-del" onClick={openModal}>
              удалить
            </p>
          )}
        </div>
      </div>

      <EditServiceCategoryForm
        serviceCategory={props.serviceCategory}
        onSubmit={props.onSubmit}
        isActive={!isCollapsed}
      />
    </div>
  );
};

export default ServiceCategory;
